import { FunctionComponent } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useNotification } from '@starjack/features/notifications';
import { B2BUserWithCredentials } from '@/models/b2b';
import { useDeleteB2BMutation } from '@/api/v2/b2b';

type B2BDeleteDialogProps = {
    b2b: B2BUserWithCredentials;
    open: boolean;
    onClose: () => void;
};

export const B2BDeleteDialog: FunctionComponent<B2BDeleteDialogProps> = ({
    b2b,
    open,
    onClose,
}) => {
    const [deleteHospitality, { isLoading }] = useDeleteB2BMutation();
    const { addNotification } = useNotification();

    const onDeleteB2B = () => {
        deleteHospitality(b2b)
            .unwrap()
            .then(() => {
                addNotification({
                    message: 'B2B erfolgreich gelöscht',
                    type: 'success',
                });
            })
            .catch(() => {
                addNotification({
                    message:
                        'Fehler beim Löschen. Bitte versuchen Sie es später noch einmal',
                    type: 'error',
                });
            })
            .finally(() => {
                onClose();
            });
    };

    return (
        <Dialog open={open}>
            <DialogTitle>B2B Löschen</DialogTitle>
            <DialogContent>
                {!!b2b && (
                    <DialogContentText>
                        Wollen Sie die B2B Verkaufsstelle{' '}
                        <Typography sx={{ fontWeight: 600 }} component='span'>
                            {b2b.name}
                        </Typography>{' '}
                        wirklich löschen?
                    </DialogContentText>
                )}
            </DialogContent>

            <DialogActions>
                <Stack spacing={2} direction='row'>
                    <Button onClick={onClose}>Abbrechen</Button>
                    <LoadingButton
                        onClick={onDeleteB2B}
                        variant='contained'
                        loading={isLoading}
                    >
                        Löschen
                    </LoadingButton>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};
